import Button, {BtnColor} from "../../../components/Button/Button";
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";

import '../styles.scss'
import {IoAddCircleOutline} from "react-icons/io5";
import {useDispatch, useSelector} from "react-redux";
import {onAppLoad, onAppSetDetails} from "../../../store/App/actions";
import Loading from "../../../components/Loading";
import {useTranslation} from "react-i18next";

const Step1 = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const photoRef = useRef(null);

    const { details: {name, subtitle, details, icon}, loading } = useSelector(({ app: { details, loading }}) => ({ details, loading }))

    const onChangeName = (e) => dispatch(onAppSetDetails('name', e.target.value))
    const onChangeSubtitle = (e) => dispatch(onAppSetDetails('subtitle', e.target.value))
    const onChangeDetails = (e) => dispatch(onAppSetDetails('details', e.target.value))
    const onChangeIcon = (file) => dispatch(onAppSetDetails('icon', file))

    const onClickAddPhoto = () => photoRef.current.click();

    const onChangePhoto = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            onChangeIcon(reader.result);
        }

        reader.readAsDataURL(file)
    }

    useEffect(() => {
        dispatch(onAppLoad());
    }, [])

    return (
        <Loading loading={loading}>
            <div className="mx-12 mt-5">
                <div className="flex justify-between items-end">
                    <div className="text-2xl font-bold w-1/3">1. {t('App Details')}</div>
                    <div className="w-52 mb-2 w-1/3">
                        <div className="text-center">{t('Step')} 1 of 4</div>
                        <div>
                            <div className="h-3 relative max-w-xl rounded-full overflow-hidden">
                                <div className="w-full h-full bg-gray-200 absolute" />
                                <div className="h-full bg-indigo-600 absolute" style={{width:'25%'}} />
                            </div>
                        </div>
                    </div>
                    <div className="flex w-1/3 justify-end">
                        <a href={'/chain/app'}>
                            <Button color={BtnColor.gray} className="ml-2 px-10">{t('Exit')}</Button>
                        </a>
                        <Link to={'/chain/app?step=2'}>
                            <Button color={BtnColor.gray} className="ml-2 px-10">{t('Next')}</Button>
                        </Link>
                    </div>
                </div>
                <div className="w-1/2 mt-5">
                    {t('The details you provide here will be pesented on the Apple App Store and Google Play Store. Provide the name, description and logo for your new branded app.')}
                </div>
                <div>

                    <div className="mt-8 w-full flex" >
                        <div className="grid grid-cols-1 gap-6 w-1/2">
                            <label className="block">
                                <span className="text-gray-700">{t('Name')}</span>
                                <input type="text"
                                       className="mt-1 block w-full rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                       placeholder=""
                                       value={name}
                                       onChange={onChangeName}
                                />
                            </label>
                            <label className="block">
                                <span className="text-gray-700">{t('Subtitle')}</span>
                                <input type="text"
                                       className="mt-1 block w-full rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                       placeholder=""
                                       value={subtitle}
                                       onChange={onChangeSubtitle} />
                            </label>
                            <label className="block">
                                <span className="text-gray-700">{t('Additional details')}</span>
                                <textarea
                                    className="mt-1 block w-full rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                    rows="3"
                                    value={details}
                                    onChange={onChangeDetails} />
                            </label>
                        </div>

                        <div className="py-3 center mx-auto flex bg-white rounded-lg shadow-lg px-4">
                            <div className=" px-4 py-5  text-center w-1/2">
                                <div className="mb-4 flex bg-blue-100 items-center file-input justify-center"
                                     onClick={onClickAddPhoto}
                                     style={{width: '200px', height: '200px', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundImage: `url(${icon})`}}>

                                    <input type="file"
                                           className="hidden"
                                           ref={photoRef}
                                           onChange={onChangePhoto} />

                                    {!icon ?(
                                        <div className="flex flex-col">
                                            <div className="items-center">{t('App icon')}</div>
                                            <div className="sub items-center">1024 x 1024 px</div>
                                            <div className="sub m-auto mt-5">
                                                <IoAddCircleOutline size={30} />
                                            </div>
                                        </div>
                                    ):null}
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </Loading>
    )
}

export default Step1
